import Meta from "@/utils/RouterMeta";
import {authService} from "~/services/AuthService";

export default class Router {

    static NEW = new this({meta: Meta.NEW})
    static addCreateButton = []

    /**
     * @param path
     * @param name
     * @param {function}component
     * @param {Router | null}children
     * @param props
     * @param appendBtn
     * @param {Meta} meta
     */
    constructor({
                    path = '', name = '',
                    component = null,
                    children = null,
                    props = null,
                    beforeEnter = null,
                    redirect = null,
                    meta = {}
                }) {

        this.path = path
        this.component = component
        this.redirect = redirect
        this.name = name
        this.beforeEnter = beforeEnter
        this.children = children
        this.props = props
        this.meta = meta
    }

    /**
     * @param path
     * @param name
     * @param component
     * @param beforeEnter
     * @param {Router[] | null}children
     * @param props
     * @param appendBtn
     * @param {Meta} meta
     * @returns {Router}
     */
    static instance({
                        path = '',
                        name = '',
                        component = () => import('@/pages/interlayer'),
                        beforeEnter = (to, from, next) => {
                            next()
                        },
                        children = null,
                        props = null,
                        appendBtn = false,
                        meta = {}
                    }) {

        if (!Router.checkedThis(meta)) {
            return Router.NEW
        }

        children = Router.checkedChildren(children)

        if (meta?.appendBtn === true) {
            Router.addCreateButton.push({
                path: `/${path.replace('/:id?', '')}`,
                title: meta?.btnName
            })
        }
        return new this({path, name, beforeEnter, appendBtn, component, children, props, meta})
    }

    /**
     *
     * @param {Meta} meta
     */
    static checkedThis(meta) {
        const permissions = meta.permissions
        if (!permissions) return true
        const user = authService.getUser()
        const find = permissions.find(permission => permission === user?.role)
        return !!find
    }

    /**
     * @param {Router[]} children
     */
    static checkedChildren(children) {
        if (Array.isArray(children)) {
            const user = authService.getUser()
            const result = children.filter((value, index, routers) => {
                const permissions = value.meta.permissions
                if (!permissions) return true
                return permissions.find(permission => permission === user?.role)
            })
            if (children.length === 0) return null
            return children
        }
        return null
    }

}